import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, flatMap, map } from 'rxjs/operators';
import { TranslationHelperService } from '../services/translations/translation-helper.service';
import { Observable } from 'rxjs';

@Pipe({
  name: 'level',
  pure: true
})
export class LevelNamePipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private translationHelper: TranslationHelperService,
  ) {}

  transform(value: any, prefix: string = 'area.level.'): Observable<string> {
    const key = (prefix ?? '') + value;

    return this.translationHelper.getLocale().pipe(
      flatMap(() => this.translate.get(key)),
      map(translation => (translation === key ? value : translation)),
      catchError(() => [value])
    );
  }
}